import './category.scss'
import type { FC } from 'react'
import { navigationService } from '@/common/services/navigation.service'
import type { SearchResult } from '@/features/layout/header/subcomponents/searchButton/useSiteSearchResults'

interface CategoryProps {
    title: string
    items: SearchResult[]
    onClick: () => void
}

export const Category: FC<CategoryProps> = ({ title, items, onClick }) => {
    const navigate = (url: string) => {
        onClick()
        navigationService.goTo(url)
    }

    return (
        <div className="category">
            <h4 className="category-title">{title}</h4>
            <div className="category-items">
                {items.map((r, i) => (
                    <div className="item" key={i} onClick={() => navigate(r.url)}>
                        <h3>{r.title}</h3>
                    </div>
                ))}
            </div>
        </div>
    )
}
